import { Typography } from '@mui/material';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useAzureBlobContainers from '~/hooks/auth/useAzureBlobContainers';
import { handleError } from '~/utils/errors';
import { downloadBlobToFiles } from '~/utils/io/files/downloadBlobAsFiles';
import LeafRenderer from './LeafRenderer';

export const AzureFileBrowser = ({
    onDownloadFiles,
}: {
    onDownloadFiles: (files: File[]) => void;
}) => {
    const [downloading, setDownloading] = useState<string>();
    const { blobContainers, loading, error, downloadBlob } =
        useAzureBlobContainers('rtviewertestdata');
    if (loading)
        return (
            <Typography variant="body2">
                <FormattedMessage id="loading" />
                ...
            </Typography>
        );
    if (error || !blobContainers)
        return (
            <Typography variant="body2">
                <FormattedMessage id="unexpectedError" />
            </Typography>
        );

    const handleFileDownload = async (
        containerName: string,
        blobPaths: string[]
    ) => {
        try {
            setDownloading(blobPaths[0]);
            const files = await downloadBlobToFiles(
                downloadBlob,
                containerName,
                blobPaths
            );
            onDownloadFiles(files);
        } catch (downloadError) {
            handleError(
                downloadError,
                'Error downloading files, please try again.'
            );
        }
        setDownloading(undefined);
    };
    return (
        <TreeView aria-label="azure-files">
            {blobContainers.map((container, index) => (
                <LeafRenderer
                    key={`1-${index}-${container.fullPath}`}
                    node={container}
                    nodeIdPrefix={`1-${index}`}
                    onFileDownload={handleFileDownload}
                    downloading={downloading}
                />
            ))}
        </TreeView>
    );
};

export default AzureFileBrowser;
